/**
 * Tree field available modes
 */
var TreeFieldMode;
(function (TreeFieldMode) {
    TreeFieldMode[TreeFieldMode["TREE_VIEW"] = 0] = "TREE_VIEW";
    TreeFieldMode[TreeFieldMode["TREE_AUTOCOMPLETE"] = 1] = "TREE_AUTOCOMPLETE";
})(TreeFieldMode || (TreeFieldMode = {}));

export { TreeFieldMode };
//# sourceMappingURL=types.js.map
